import { render, staticRenderFns } from "./profile-edition-educational.vue?vue&type=template&id=00e6f25a&"
import script from "./profile-edition-educational.vue?vue&type=script&lang=js&"
export * from "./profile-edition-educational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/QI.Recrutement.FE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import UiAction from '@/components/ui/action.vue'
import UiMaxWidth from '@/components/ui/max-width.vue'
import UiStepper from '@/components/ui/stepper.vue'
import UiStepperContent from '@/components/ui/stepper-content.vue'
import UiStepperStep from '@/components/ui/stepper-step.vue'
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLabel } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {UiAction,UiMaxWidth,UiStepper,UiStepperContent,UiStepperStep,VAlert,VBtn,VCard,VCardText,VCheckbox,VContainer,VForm,VIcon,VLabel,VRadio,VRadioGroup,VTextField,VTextarea,VTooltip})
